import LabelIcon from '@mui/icons-material/Label';
import { Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import formatString from '@utils/formatString';

export const Metadata = ({ item }) => (
  <Card variant="outlined" sx={{ mb: 3 }}>
    <CardContent>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <LabelIcon color="action" /> Analysis Metadata
      </Typography>

      <Card sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }} variant="outlined">
        <Stack direction="column" sx={{ flex: 1, textAlign: 'center', gap: 1 }}>
          <Typography variant="h6" color="primary" fontWeight="bold">
            {new Date(item.created_at?.$date || item.created_at).toLocaleString()}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Created
          </Typography>
        </Stack>
        <Divider orientation="vertical" flexItem />
        <Stack direction="column" sx={{ flex: 1, textAlign: 'center', gap: 1 }}>
          <Chip
            label={formatString(item.analysis_lens_type || 'N/A')}
            size="small"
            color="primary"
            sx={{
              width: 'fit-content',
              margin: 'auto',
              borderRadius: 1,
              mt: 1,
            }}
          />
          <Typography variant="body2" color="text.secondary">
            Lens Type
          </Typography>
        </Stack>
        <Divider orientation="vertical" flexItem />
        <Stack direction="column" sx={{ flex: 1, textAlign: 'center', gap: 1 }}>
          <Typography variant="h6" color="primary" fontWeight="bold">
            {item.qualitative_items_included?.length ?? 0}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Transcript Count
          </Typography>
        </Stack>
      </Card>
    </CardContent>
  </Card>
);
